import { push } from 'connected-react-router'
import queryString from 'query-string'
import { isEmpty, isNil, path } from 'ramda'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { bindActionCreators } from 'redux'

import { setAccessToken } from '@driftt/web-auth'

import Loading from 'layouts/LoadingPage'
import * as OrgActions from 'modules/org/actions'
import { api } from 'modules/org/api'
import { identifyUser } from 'utils/trackingUtils'

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      createOrgSuccess: OrgActions.createOrgSuccess,
      push,
    },
    dispatch
  ),
})

export default compose(
  connect(null, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const relayToken = path(
        ['emailVerifyToken'],
        queryString.parse(this.props.location.search)
      )
      if (isNil(relayToken) || isEmpty(relayToken)) {
        this.props.actions.push('/start/verify/expired')
      }
      api
        .verifyToken(relayToken)
        .then(({ data }) => {
          const token = data.accessToken.accessToken
          setAccessToken({ token: token })
          identifyUser(undefined, data.organization.id, data.user.id)
          this.props.actions.createOrgSuccess(data)
        })
        .finally(() =>
          this.props.actions.push('/setup/touchless/welcome?verified=true')
        )
        .catch((err) => {
          console.error(err)
          this.props.actions.push('/start/verify/expired')
        })
    },
  })
)(Loading)
